import { render } from "./getDriver.vue?vue&type=template&id=64e11084&scoped=true"
import script from "./getDriver.vue?vue&type=script&lang=js"
export * from "./getDriver.vue?vue&type=script&lang=js"

import "./getDriver.vue?vue&type=style&index=0&id=64e11084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e11084"]])

export default __exports__